import gql from 'graphql-tag'

export const GetComplianceByUser = () => (gql`query GetComplianceByUser{
    getComplianceByUser{
        hipaaQuizScore
        securityQuizScore
        hipaaQuizCompleted
        securityQuizCompleted
        totalMonthlyQuizScore
        completedMonthlyQuizzes
        email
        name
    }
  }`
  );

  export const GetTrainingByUser = () => (gql`query GetTrainingByUser ($input: String!){
    getTrainingByUser(input: $input){
        completedMonthlyQuizzes
        email
        name
        quizCompleted
        quizScore
        totalMonthlyQuizScore
        overallScore
    }
  }`
  );


// WEBPACK FOOTER //
// ./src/queries/training.js